var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38103 25.3333C5.22512 25.3333 2.66675 22.8051 2.66675 19.6863C2.66675 16.5675 5.22512 14.0392 8.38103 14.0392C8.75986 14.0392 9.13008 14.0756 9.48829 14.1452M19.1747 10.7029C19.969 10.4255 20.8239 10.2745 21.7144 10.2745C22.5873 10.2745 23.4259 10.4196 24.2069 10.6866M9.48829 14.1452C9.18283 13.3304 9.01595 12.4492 9.01595 11.5294C9.01595 7.37103 12.4271 4 16.635 4C20.5546 4 23.7829 6.92495 24.2069 10.6866M9.48829 14.1452C10.2409 14.2912 10.9405 14.5832 11.5556 14.9901M24.2069 10.6866C27.1907 11.707 29.3334 14.5082 29.3334 17.8039C29.3334 21.4133 26.7636 24.4294 23.3334 25.163",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 21.3334V29.3334M15.9999 21.3334L18.6666 24M15.9999 21.3334L13.3333 24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBig);
export default __webpack_public_path__ + "static/media/uploadBig.d51f7380f978cea8168ddbbc78aa3f5b.svg";
export { ForwardRef as ReactComponent };